import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { get } from 'lodash';
import { useTranslation } from '../../src/i18n';
import { colors } from '../../constants/styleConstants';
import SideCard from '../StubPageSideCard';
import ReviewsCard from '../ReviewsCard';
import ImageGalleryView from '../ImageGalleryView';
import VideoCard from '../VideoCard';
import ArtistInfoCard from '../ArtistInfoCard';
import { TP } from '../../constants/consts';
import ArtistRepertoireView from '../ArtistRepertoireView';
import ArtistContactSideCard from '../ArtistContactSideCard';

const useStyles = makeStyles({
  info: {
    display: 'flex',
  },
  sideCard: {
    marginBottom: 20,
  },
  artistSideCard: {
    marginBottom: '20px',
  },
  classNameContent: {
    paddingLeft: 0,
    paddingTop: 0,
  },
  artistCard: {
    padding: '0 !important',
  },
  reviewsCard: {
    padding: 0,
  },
  rightArrow: {
    fontSize: '1.1rem',
    color: colors.blueChip,
  },
});

const ArtistSidebar = ({
  photos,
  profile,
  videos,
  repertoire,
  isLoggedIn,
  reviews,
  bio,
  agreementData,
  artistBio,
  goToTab,
  lang,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.asideBlock}>
      {repertoire?.total > 0 && (
        <ArtistRepertoireView
          showMoreCard
          all={repertoire?.short?.all}
          future={repertoire?.short?.future}
          retired={[]}
          active={[]}
          goToTab={goToTab}
          profile={profile}
        />
      )}

      {(artistBio?.content || profile?.description) && (
        <SideCard
          className={classes.artistSideCard}
          classNameContent={classes.classNameContent}
          title={t(`${TP}.m_ARTIST_BIOGRAPHY`)}
          tabName="bio"
          titleActionComponent={<ArrowForwardIcon className={classes.rightArrow} onClick={() => goToTab('bio')} />}
        >
          <ArtistInfoCard
            isLoggedIn={isLoggedIn}
            className={classes.artistCard}
            bio={bio}
            artistBio={artistBio}
            profile={profile}
            isBio
            maxLines={2}
            lang={lang}
          ></ArtistInfoCard>
        </SideCard>
      )}
      {!!videos?.length && (
        <VideoCard
          title={t(`${TP}.m_ARTIST_VIDEOS`)}
          tabName="videos"
          videos={videos}
          maxCountVideos={3}
          goToTab={goToTab}
        />
      )}
      {!!photos?.length && (
        <ImageGalleryView
          title={t(`${TP}.m_IMAGES`)}
          tabName="images"
          images={photos.map(i => ({
            ...i,
            srcPreview: i?.file?.urls?.small || i?.url,
            srcView: i?.file?.urls?.large || i?.url,
            alt: i?.title,
            descriptionTitle: i?.description,
          }))}
          goToTab={goToTab}
          maxCountImages={4}
        />
      )}
      {!!reviews?.data.length && (
        <SideCard
          className={classes.sideCard}
          classNameContent={classes.reviewsCard}
          title={t(`${TP}.m_ARTICLE`)}
          titleActionComponent={<ArrowForwardIcon onClick={() => goToTab('reviews')} className={classes.rightArrow} />}
          isNoShow={get(reviews, 'data', []).length === 0}
        >
          <ReviewsCard goToTab={goToTab} reviews={get(reviews, 'data', []).slice(0, 2)} isSmall profile={profile} />
        </SideCard>
      )}
      {!!get(profile, 'agencies', []).length || !!get(profile, 'contacts', []).length ? (
        <ArtistContactSideCard
          goToTab={goToTab}
          profile={profile}
          isLoggedIn={isLoggedIn}
          agreementData={agreementData}
        />
      ) : null}
    </div>
  );
};

export default ArtistSidebar;
